import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Observable } from 'rxjs';
import { AppointmentData, MDAppoinmentData, MRIAppoinmentData, NeuroAppoinmentData, OrthoAppoinmentData, PainAppoinmentData, PainManagementData } from './make-appoinment.model';

@Injectable({
  providedIn: 'root'
})
export class MakeAppointmentService {
  constructor(private apiService: HttpService) {}

  /* MD */
  getMDAppoinment(id: number): Observable<any> {
    return this.apiService.getData<AppointmentData<MDAppoinmentData>>(`Appointment/GetMDAppointment?patientId=${id}`);
  }

  makeMDAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.postData<MDAppoinmentData>('Appointment/AddMDAppointment', data);
  }

  updateMDAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.putData<MDAppoinmentData>(`Appointment/UpdateMDAppointment/${data.patientId}`, data);
  }
  /* MRI */
  getMRIAppoinment(id: number): Observable<any> {
    return this.apiService.getData<AppointmentData<MRIAppoinmentData>>(`Appointment/GetMRIAppointment?patientId=${id}`);
  }

  makeMRIAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.postData<MRIAppoinmentData>('Appointment/AddMRIAppointment', data);
  }

  updateMRIAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.putData<MRIAppoinmentData>(`Appointment/UpdateMRIAppointment/${data.patientId}`, data);
  }

  /* Neuro */
  getNeuroAppoinment(id: number): Observable<any> {
    return this.apiService.getData<AppointmentData<NeuroAppoinmentData>>(`Appointment/GetNeuroAppointment?patientId=${id}`);
  }

  makeNeuroAAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.postData<NeuroAppoinmentData>('Appointment/AddNeuroAppointment', data);
  }

  updateNeuroAAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.putData<NeuroAppoinmentData>(`Appointment/UpdateNeuroAppointment/${data.patientId}`, data);
  }

  /* Ortho */
  getOrthoAppoinment(id: number): Observable<any> {
    return this.apiService.getData<AppointmentData<OrthoAppoinmentData>>(`Appointment/GetOrthoAppointment?patientId=${id}`);
  }

  makeOrthoAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.postData<OrthoAppoinmentData>('Appointment/AddOrthoAppointment', data);
  }

  updateOrthoAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.putData<OrthoAppoinmentData>(`Appointment/UpdateOrthoAppointment/${data.patientId}`, data);
  }

  /* Pain */
  getPainAppoinment(id: number): Observable<any> {
    return this.apiService.getData<AppointmentData<PainAppoinmentData>>(`Appointment/GetPainAppointment?patientId=${id}`);
  }

  makePainAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.postData<PainAppoinmentData>('Appointment/AddPainAppointment', data);
  }

  updatePainAppoinment(data: MDAppoinmentData): Observable<any> {
    return this.apiService.putData<PainAppoinmentData>(`Appointment/UpdatePainAppointment/${data.patientId}`, data);
  }
}
